import { motion } from 'framer-motion';
import styled from 'styled-components';

import { Button } from '@pkg/components/Sections/Profile/Buttons';

export const StyledButton = styled(Button)`
    width: 145px !important;
    cursor: pointer;
    position: relative;
`;

export const StyledAddButton = styled(Button)`
    white-space: nowrap;
`;

export const RemoveActionWrapper = styled(motion.div)`
    svg {
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        width: 40px;
        margin-right: 20px;
        &:hover {
            transform: scale(0.85);
        }
    }
`;

export const ConfirmationWrapper = styled(motion.div)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const BaseActionsWrapper = styled.div`
    display: flex;
    gap: 15px;
`;

export const CopyWrapper = styled.span`
    margin-left: 10px;
`;

export const ToastActionsWrapper = styled(motion.div)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;
